import { connect } from 'react-redux';

import BillToTab from './BillToTab';
import { updateDeal } from '../../../redux/actions/deal-actions';
import { addDealContact, fetchDealContacts, updateDealContact, deleteDealContact } from '../../../redux/actions/deal-contacts-actions';
import { fetchCommissions } from '../../../redux/actions/voucher/commissions-actions';
import { toast } from '../../../redux/actions/toasts-actions';

const mapStateToProps = state => ({
  deal: state.deal.deal,
  voucher: state.voucher.voucher,
  contactInfo: state.dealContacts.contacts,
  primaryContact: state.dealContacts.primaryContact,
  commissions: state.commissions.commissions,
  outsideBrokerCommissions: state.outsideBrokerCommissions.commissions,
});

const mapDispatchProps = {
  updateDeal,
  fetchCommissions,
  addDealContact,
  fetchDealContacts,
  updateDealContact,
  deleteDealContact,
  toast,
};


const BillToTabContainer = connect(
  mapStateToProps,
  mapDispatchProps,
)(BillToTab);

export default BillToTabContainer;
